/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { NotificationSearchResponseDto } from '../../models/notification-search-response-dto';

export interface NotificationControllerSearchV1$Params {

/**
 * 페이지 크기
 */
  pageSize: number;

/**
 * 정렬 기준
 */
  orderBy?: string;

/**
 * 정렬 방향
 */
  align?: 'asc' | 'desc';

/**
 * 검색어
 */
  query?: string;

/**
 * 페이지 번호
 */
  pageNo: number;

/**
 * 센터 ID
 */
  centerId?: string;

/**
 * 사용자 ID (관리자 검색용)
 */
  userId?: string;

/**
 * 요청자 역할
 */
  memberRole?: 'PARENT' | 'TEACHER';
}

export function notificationControllerSearchV1(http: HttpClient, rootUrl: string, params: NotificationControllerSearchV1$Params, context?: HttpContext): Observable<StrictHttpResponse<NotificationSearchResponseDto>> {
  const rb = new RequestBuilder(rootUrl, notificationControllerSearchV1.PATH, 'get');
  if (params) {
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('align', params.align, {});
    rb.query('query', params.query, {});
    rb.query('pageNo', params.pageNo, {});
    rb.query('centerId', params.centerId, {});
    rb.query('userId', params.userId, {});
    rb.query('memberRole', params.memberRole, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<NotificationSearchResponseDto>;
    })
  );
}

notificationControllerSearchV1.PATH = '/api/v1/notification/search';
